<template>
    <div class="mt4 content">
        <div class="columns pt-6">
            <div class="column">
                <p class="has-text-white" v-if="!availableConferences"><i class="fas fa-spin fa-spinner fa-fw mr-3"></i>Please wait. Loading conferences...</p>
                <div v-else>
                    <section class="pb-4" v-if="featuredConferences.length > 0">
                        <h2 class="mb-1 mb-6 has-text-white"><i class="fad fa-calendar-alt fa-fw mr-3"></i>Upcoming & Recent Conferences</h2>

                        <conference :conference="c" v-for="c in featuredConferences" class="mb-5 mr-6"/>
                    </section>

                    <section class="pb-6">
                        <h2 class="mb-1 mt-6 mb-3 has-text-white" v-if="featuredConferences.length > 0"><i class="fad fa-presentation fa-fw mr-3"></i>All Conferences</h2>

                        <b-tabs class="conference-tabs" :animated="false">
                            <template v-for="tab in years">
                                <b-tab-item>
                                    <template #header><i class="fad fa-calendar mr-3"></i>{{tab}}</template>

                                    <conference :conference="c" v-for="c in getByYear(tab)" class="mb-5 mr-6"/>

                                </b-tab-item>
                            </template>
                        </b-tabs>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Conference from "../../components/Conference";
    import {client as http} from "../../http_client";
    import moment from "moment";

    export default {
        components: {Conference},
        data: function() {
            return {
                conferences: null,
                years: Array.from({length: 6}, (v, k) => new Date().getFullYear() - k)
            };
        },
        computed: {
            featuredConferences: function() {
                if (this.conferences) {
                    // return conferences that start_at within the next 30 days or within the last 14 days
                    return this.conferences.filter(c => {
                        let start = moment(c.start_at);
                        return start.isBetween(moment(), moment().clone().add(30, 'days')) ||
                            start.isBetween(moment().clone().subtract(14, 'days'), moment()) || c.is_highlighted;
                    });


                } else {
                    return [];
                }
            },
            availableConferences: function() {
                if (this.conferences) {
                    return this.conferences.filter(c => new Date(c.start_at).getFullYear() >= new Date().getFullYear() - 5);
                } else {
                    return [];
                }
            }
        },
        methods: {
            // get conferences by year
            getByYear(year) {
                if (this.conferences) {
                    return this.conferences.filter(c => new Date(c.start_at).getFullYear() === year);
                } else {
                    return [];
                }
            }
        },
        mounted() {
            http.get('app/conferences/', {force: true}).then(response => {
                this.conferences = response.data;
            });
        }
    };
</script>

<style lang="scss" scoped>
    h2 {
        font-size: 1.2rem;
        color: white;
        padding-bottom: 0.5rem;
        margin-bottom: 1rem;
        border-bottom: 1px dashed rgba(255, 255, 255, 0.2);

        i {
            color: white;
        }
    }
</style>

<style lang="scss">
    .conference-tabs {

        .tabs {
            color: white;
            margin-bottom: 50px;

            ul {
                margin: 0;
                padding: 0;
            }

            li a {
                color: #9faec2 !important;
                font-size: 0.9rem;

                &:hover {
                    border-bottom-color: #6f8295;
                }
            }

            li.is-active a {
                color: #ffffff !important;
                border-bottom-color: #6f8295;
                font-size: 0.9rem;

            }
        }

        .tab-content {
            padding: 1rem 0 0 !important;
        }
    }

</style>
